import { X, RefreshCw, AlertCircle, Image as ImageIcon } from "lucide-react";
import { Input } from "../ui/input";
import { Progress } from "../ui/progress";

export const PhotoPreviewGrid = ({ photos, onRemove, onCaptionChange, onCaptionSave, onRetry, onView }) => {
  if (!photos?.length) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-testid="photo-preview-grid">
      {photos.map((photo, idx) => (
        <div
          key={photo.localId}
          className="rounded-xl border border-gray-200 bg-white overflow-hidden"
          data-testid={`photo-card-${idx}`}
        >
          <div className="relative aspect-square bg-gray-100">
            {photo.status === "error" ? (
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 p-3 text-center">
                <AlertCircle className="w-6 h-6 text-red-500" />
                <p className="text-xs text-red-600 line-clamp-2">{photo.error || "Upload failed"}</p>
                <button
                  type="button"
                  onClick={() => onRetry(photo.localId)}
                  className="text-xs font-medium text-[#0FA3B1] flex items-center gap-1 hover:underline"
                  data-testid={`photo-retry-${idx}`}
                >
                  <RefreshCw className="w-3 h-3" /> Retry
                </button>
              </div>
            ) : (
              <button
                type="button"
                className="absolute inset-0 w-full"
                onClick={() => onView && photo.previewUrl && onView(idx)}
                data-testid={`photo-thumb-${idx}`}
              >
                {photo.previewUrl ? (
                  <img src={photo.previewUrl} alt={photo.name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <ImageIcon className="w-8 h-8 text-gray-300" />
                  </div>
                )}
              </button>
            )}
            <button
              type="button"
              onClick={() => onRemove(photo.localId)}
              className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center transition-colors"
              aria-label="Remove photo"
              data-testid={`photo-remove-${idx}`}
            >
              <X className="w-4 h-4" />
            </button>
            {photo.status === "uploading" && (
              <div className="absolute bottom-0 left-0 right-0 bg-black/50 px-3 py-2">
                <Progress value={photo.progress} className="h-1.5" />
                <p className="text-[10px] text-white mt-1">Uploading… {photo.progress}%</p>
              </div>
            )}
          </div>
          <div className="p-2">
            <Input
              value={photo.caption}
              onChange={(e) => onCaptionChange(photo.localId, e.target.value)}
              onBlur={() => onCaptionSave && onCaptionSave(photo.localId)}
              placeholder="Add a caption (optional)"
              maxLength={300}
              className="text-xs h-8"
              disabled={photo.status === "error"}
              data-testid={`photo-caption-${idx}`}
            />
            <p className="text-[10px] text-[#1F2933]/40 mt-1 truncate">{photo.name}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
